interface AgentWithID {
  id: string;
}

const TUNTUN_BUILDER_AGENT_ID = 'tuntun-builder';
const TUNTUN_AGENT_PREFIX = 'tuntun-';

export function isAgentAllowedByList(agentId: string, allowedAgents: readonly string[]): boolean {
  if (allowedAgents.length === 0) return true;
  if (allowedAgents.includes(agentId)) return true;

  return allowedAgents.includes(TUNTUN_BUILDER_AGENT_ID) && agentId.startsWith(TUNTUN_AGENT_PREFIX);
}

export function filterAgentsForAllowedList<T extends AgentWithID>(
  agents: T[],
  allowedAgents: readonly string[] = [],
): T[] {
  if (allowedAgents.length === 0) return agents;
  return agents.filter((agent) => isAgentAllowedByList(agent.id, allowedAgents));
}
